import axios from 'axios'
import router from '@/router'
import utils from './utils'
import { getStore, keys,clearStore } from '@/store';

axios.defaults.baseURL = 'https://management.twinkletalk.com.cn'//正式
// axios.defaults.baseURL = 'https://test.edu.yuejike.com'//测试环境
axios.interceptors.request.use(config => {
  // 每次请求后台的时候，如果有token，需要请求头携带token。
  // if (utils.getCookie('token')) {
  //   store.getUser().token = utils.getCookie('token')
  // }
  // console.log(store.getUser().token)
  config.headers.Authorization = `Bearer ${getStore(keys.token)}`
  config.headers.lan = getStore(keys.lang)?getStore(keys.lang):((navigator.language == 'zh-CN')?'zh_CN': 'en')
  return config
}, err => Promise.reject(err))
axios.interceptors.response.use(res => {
  if (utils.GetQueryString('invite_code')) {
    if(utils.GetQueryString('salecard')){
      router.push({
        path: '/salecard?invite_code=' + utils.GetQueryString('invite_code')
      })
    }
    else if(utils.GetQueryString('nuinfo')){
      router.push({
        path: '/nuinfo?invite_code=' + utils.GetQueryString('invite_code')
      })
    }
    else{
      router.push({
      // path: '/shareRegister?invite_code=' + utils.GetQueryString('invite_code')
      //   + '&utm_medium=' + utils.GetQueryString('utm_medium')
        // +        '&utm_source=' + utils.GetQueryString('utm_source')
        // +        '&utm_campaign=' + utils.GetQueryString('utm_campaign')
      })
    }

  } else if (res.data.code === 10001) {
    router.push('/')
    clearStore()
  }
  return res
}, err => {
  // 根据当前的响应状态码是不是401去跳转登录页面

  // 状态码  err.response.status 就是
  if (err.response.status === 401) {
    router.push('/')
  }

  return Promise.reject(err)
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js